import axios from 'axios';
import isSameDay from 'date-fns/isSameDay';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import { toDate } from 'date-fns-tz';

export const isDateWithinContracts = (date, contracts) => {
  // is the date within a contract?
  return Boolean(
    contracts?.find((c) => {
      const startDate = toDate(c.startDate, {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      const endDate = toDate(c.endDate, {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      if (
        isSameDay(date, startDate) ||
        isSameDay(date, endDate) ||
        (isAfter(date, startDate) && isBefore(date, endDate))
      ) {
        return true;
      }
      return false;
    })
  );
};

export const getClaimAmountInUsd = async (sourceCurrency, claimAmount) => {
  const res = await axios.get(
    `https://api.currencylayer.com/live?access_key=${process.env.REACT_APP_CURRENCYLAYER_ACCESS_KEY}&source=${sourceCurrency}&currencies=USD&format=1`
  );
  const rate = res.data?.quotes?.[`${sourceCurrency}USD`];
  return rate * claimAmount;
};

export const cleanData = (values) => {
  const cleanedValues = { ...values };
  Object.keys(cleanedValues).forEach((key) => {
    const value = cleanedValues[key];
    if (typeof value === 'object' && value !== null) {
      cleanedValues[key] = cleanData(value); // Call function recursively for nested objects
    } else if (value === '' || value === false) {
      delete cleanedValues[key];
    }
  });
  return cleanedValues;
};
